import React, { Component } from 'react';
import axios from 'axios';
import Qs from 'qs';
import Conf from 'utils/Conf';
import Button from '@material-ui/core/Button';
import CircularProgress from "@material-ui/core/CircularProgress";
import 'components/BookButton.scss';
import { withTranslation } from 'react-i18next';

class BookButton extends Component {
    constructor(props){
        super(props);
        this.state={
            pending:false,
            soldOut:false,
        }
        this.book=this.book.bind(this);
    }
    book(){
        const { appState, seance, ed, methods } = this.props;
        if (!appState.user.email) {
            return ed.trigger('loginRegisterOpen');
        }

        this.setState({
            pending: true,
        });

        axios.post(`${Conf.apiBaseUriLegacy}/book/${seance.seance_id}`, Qs.stringify({}), { withCredentials: true })
            .then((r) => {
                if (r.data.status === 'OK') {
                    methods.getProfile();
                }
                if (r.data.status === 'SOLD OUT') {
                    this.setState({
                        soldOut: true,
                        pending: false,
                    });
                }
                return null;
            });
    }
    render() {
        let { seance, t } = this.props;
        const { pending, soldOut } = this.state;

        const commonProps = {
            className: 'seance-btn',
            size: 'small',
            variant: 'contained',
            color: 'primary',
        };

        if (!seance.local) {
            return (
                <Button
                    {...commonProps}
                    disabled
                >
                    {t('seance-hors-de-votre-zone')}
                </Button>
            );
        }

        if (pending) {
            return (
                <Button
                    {...commonProps}
                    disabled={seance.cantBuy}
                >
                    <CircularProgress size="20px" color="inherit" />
                </Button>
            );
        }

        if (soldOut) {
            return (
                <Button {...commonProps}>
                    {t('seance-complete')}
                </Button>
            )
        }

        return (
            <Button
                {...commonProps}
                disabled={seance.cantBuy}
                onClick={this.book}
            >
                {t('reserver')}
            </Button>
        );
    }
}
export default withTranslation()(BookButton);
